import {
	Column,
	ContextMenuInfo,
	DialogInfo,
	DynamicInfo,
	FileUploadInfo,
	FloatNotificationInfo,
	LoginInfo,
	PromptInfo,
	SiteContent,
	ToastInfo,
} from "@/types";
import { signal } from "@preact/signals";

export const arePopupsOpen = signal({
	about: false,
	addSite: false,
	apiKeys: false,
	settings: false,
	ssl: false,
});
export const changedFiles = signal<string[]>([]);
export const contextMenuInfo = signal<ContextMenuInfo | null>(null);
export const currentColumn = signal<Column>(Column.SITE_LIST);
export const currentFile = signal<string>("");
export const currentFolder = signal<string>("");
export const currentSite = signal<string>("");
export const dialog = signal<DialogInfo>({});
export const dynamicInfo = signal<DynamicInfo>({});
export const files = signal<SiteContent>({
	"settings.rth": {
		home: "index.html",
	},
});
export const floatNotificationInfo = signal<FloatNotificationInfo | null>(null);
export const hasPremium = signal<boolean | null>(null);
export const hasUnsaved = signal<boolean>(false);
export const isAiBarShown = signal<boolean>(false);
export const isClosingDialog = signal<boolean>(false);
export const isClosingSidebar = signal<boolean>(false);
export const isClosingToast = signal<boolean>(false);
export const isLoadingShown = signal<boolean>(false);
export const isLoginPanelShown = signal<boolean>(false);
export const isMainMenuShown = signal<boolean>(false);
export const isMonacoEnabled = signal<boolean>(false);
export const isSplashScreenShown = signal<boolean>(true);
export const login = signal<LoginInfo>({});
export const oldDomain = signal<string>("");
export const pendingUploadFiles = signal<FileUploadInfo[]>([]);
export const premiumRemaining = signal<number>(0);
export const prompt = signal<PromptInfo>({});
export const selectedFiles = signal<string[]>([]);
export const sites = signal<string[]>([]);
export const toast = signal<ToastInfo | null>(null);
